// EDIT THIS TEXT FOR FINAL COPY
// This file contains all editable content for the egta Amsterdam 2026 download page.
// The email itself is set in functions/sendDownloadEmail.js under 'egta-2026'.

export const EGTA_2026_CONTENT = {
  // Page metadata
  pageTitle: 'Agentic AI for demand | egta Amsterdam 2026 | Syllepsis',
  pageDescription: 'The slides from the Syllepsis session at the egta Marketing and Sales Meeting, Amsterdam 2026',

  // Page header
  eyebrow: 'egta Marketing and Sales Meeting, Amsterdam 2026',
  headerTitle: 'Agentic AI for demand',
  headerSubtitle:
    'What the demand side is planning and doing with agentic AI, and what it needs. Enter your details and we will email you the slides.',

  // Form labels and validation
  form: {
    nameLabel: 'Full name',
    namePlaceholder: 'Your full name',
    emailLabel: 'Work email',
    emailPlaceholder: 'your.email@company.com',
    consentLabel: 'I agree to receive the slides by email and to be contacted by Syllepsis about related services.',
    submitButton: 'Email me the slides',
    submittingButton: 'Sending...',
  },

  // Success/Error messages
  messages: {
    success: 'Thank you. The slides are on their way, so check your inbox in a minute or two.',
    error: 'Something went wrong. Please try again or email us at info@syllepsis.io.',
  },
}
